import { Box, Stack, Typography } from "@mui/material";
import { alpha, styled, type Theme } from "@mui/material/styles";

import { getTooltipSurface, TOOLTIP_SLIDER_WIDTH } from "./constants";

const onSurface = (theme: Theme) => getTooltipSurface(theme).onSurface;

export const Root = styled(Stack)(({ theme }) => ({
  width: TOOLTIP_SLIDER_WIDTH,
  gap: theme.spacing(0.75),
}));

export const Viewport = styled(Box)({
  overflow: "hidden",
});

export const Container = styled(Box)({
  display: "flex",
  alignItems: "flex-start",
});

export const Slide = styled(Box)({
  flex: "0 0 100%",
  minWidth: 0,
});

export const Nav = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(0.5),
}));

export const NavButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 0,
  border: "none",
  background: "none",
  cursor: "pointer",
  color: onSurface(theme),

  "&:disabled": {
    cursor: "default",
    color: alpha(onSurface(theme), 0.3),
  },

  "& .MuiSvgIcon-root": {
    fontSize: 16,
  },
}));

export const Counter = styled(Typography)(({ theme }) => ({
  fontSize: 11,
  color: alpha(onSurface(theme), 0.6),
}));
